import { dashboardMeetings } from '@/modules/meeting/store/meeting.state';
import { MeetingCollection } from '@/modules/meeting/models/MeetingCollection';
import { Meeting } from '@/modules/meeting/models/Meeting';
import EventBus from '@/modules/core/app/helpers/EventBus';
import { MeetingEvent } from '@/modules/meeting/constants/MeetingEvent';

export function setDashboardMeetings(meetings: Meeting[]): void {
  const collection: MeetingCollection = new MeetingCollection(meetings);
  const shouldSendEvent: boolean = !dashboardMeetings.value.hasItems && collection.hasItems;

  dashboardMeetings.value = collection;
  if (shouldSendEvent)
    EventBus.signal(MeetingEvent.DASHBOARD_MEETINGS_LOADED, dashboardMeetings.value);
}
